import 'leaflet/dist/leaflet.css';
import './index.scss';

import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import type { FC } from 'react';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';

// Fix Leaflet's default marker icon path issue with Vite
L.Icon.Default.mergeOptions({
	iconRetinaUrl: markerIcon2x,
	iconUrl: markerIcon,
	shadowUrl: markerShadow,
});

interface ILocationMap {
	latitude: number;
	longitude: number;
	height?: string;
}

const LocationMap: FC<ILocationMap> = ({ latitude, longitude, height = '250px' }) => (
	<div
		className='location-map-container'
		style={{ height }}
	>
		<MapContainer
			center={[latitude, longitude]}
			zoom={15}
			scrollWheelZoom={false}
			style={{ width: '100%', height: '100%' }}
		>
			<TileLayer
				attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
			/>
			<Marker position={[latitude, longitude]}>
				<Popup>Your detected location</Popup>
			</Marker>
		</MapContainer>
	</div>
);

export default LocationMap;
